import * as React from 'react';
import './ProductAccessories.styles.less';
import {IProductAccessoriesProps} from "./ProductAccessories.types";
import { Col, Row } from 'antd';
import { imageUrl } from 'theme/libs/util';

export const ProductAccessories = (props:IProductAccessoriesProps) => {
    return (
        <div className='apparelAccessoryContainer'>
            <Row gutter={16}>
            {props.accessoryImages.map((img:any, i:number) => {
                return <Col key={i} span={8}  className="eachSlider">
                    <>
                        <img className="lazy" 
                            src={imageUrl(img, { t: "image/png", b:"#f2f1f6" })}
                        />
                        <br />
                        <div className='imgTitle'>{props.accessoryMetadata.filter((meta:any) => meta.title.toLowerCase().indexOf(`_title_${i+1}`) >= 0)[0]?.body}</div> 
                        <div className='subTitle'>{props.accessoryMetadata.filter((meta:any) => meta.title.toLowerCase().indexOf(`_subtitle_${i+1}`) >= 0)[0]?.body}</div> 
                    </>
                </Col>
            }
            )} 
            </Row>     
        </div>
    )
    // return (
    //     <>
    //     <Row>
    //         <Col span={12} push={props.displayReverse ? 12 : 0}>
    //             <img className='prodAccessoryImage'
    //                 src={imageUrl(props.image)}
    //             />
    //         </Col>
    //         <Col span={12} pull={props.displayReverse ? 12 : 0}>
    //             <div className={props.displayReverse ? 'displayReverse copyTextParent' : 'copyTextParent'}>
    //                 <div className='copyTextChild' dangerouslySetInnerHTML={{ __html: props.copyBlock }} />  
    //                 <br />
    //                 <Link to={props.link}>{props.buttonText}</Link>
    //             </div>       
    //         </Col>
    //     </Row>
    //     </>
    // )
}